import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useTranslation } from "react-i18next";

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="font-sans">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-600 transition-colors"
            aria-label="Go back"
          >
            <ChevronLeft className="w-6 h-6 relative mb-[2px]" />
          </button>
          <h1 className="text-xl font-bold">{t("privacyPage.title")}</h1>
        </div>
      </header>

      {/* Content - all text via t() for i18n */}
      <div className="bg-white dark:bg-transparent max-w-2xl mx-auto px-4 py-6 space-y-6 text-gray-700 dark:text-gray-300">
        <p className="text-xs text-gray-500 dark:text-gray-400">{t("privacyPage.lastUpdated")}</p>
        <p>{t("privacyPage.intro")}</p>

        <Section title={t("privacyPage.collectTitle")}>
          <p>{t("privacyPage.collectLead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li><span className="font-medium">{t("privacyPage.collectItem1Label")}</span>{" "}{t("privacyPage.collectItem1")}</li>
            <li><span className="font-medium">{t("privacyPage.collectItem2Label")}</span>{" "}{t("privacyPage.collectItem2")}</li>
            <li><span className="font-medium">{t("privacyPage.collectItem3Label")}</span>{" "}{t("privacyPage.collectItem3")}</li>
            <li><span className="font-medium">{t("privacyPage.collectItem4Label")}</span>{" "}{t("privacyPage.collectItem4")}</li>
          </ul>
        </Section>

        <Section title={t("privacyPage.useTitle")}>
          <p>{t("privacyPage.useLead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>{t("privacyPage.useItem1")}</li>
            <li>{t("privacyPage.useItem2")}</li>
            <li>{t("privacyPage.useItem3")}</li>
            <li>{t("privacyPage.useItem4")}</li>
          </ul>
        </Section>

        <Section title={t("privacyPage.paymentsTitle")}>
          <p>{t("privacyPage.paymentsBody")}</p>
        </Section>

        <Section title={t("privacyPage.sharingTitle")}>
          <p>{t("privacyPage.sharingBody")}</p>
        </Section>

        <Section title={t("privacyPage.securityTitle")}>
          <p>{t("privacyPage.securityBody")}</p>
        </Section>

        <Section title={t("privacyPage.retentionTitle")}>
          <p>{t("privacyPage.retentionBody")}</p>
        </Section>

        <Section title={t("privacyPage.rightsTitle")}>
          <p>{t("privacyPage.rightsLead")}</p>
          <ul className="list-disc pl-5 space-y-1 mt-2">
            <li>{t("privacyPage.rightsItem1")}</li>
            <li>{t("privacyPage.rightsItem2")}</li>
            <li>{t("privacyPage.rightsItem3")}</li>
          </ul>
          <p className="mt-2">{t("privacyPage.rightsFooter")}</p>
        </Section>

        <Section title={t("privacyPage.childrenTitle")}>
          <p>{t("privacyPage.childrenBody")}</p>
        </Section>

        <Section title={t("privacyPage.changesTitle")}>
          <p>{t("privacyPage.changesBody")}</p>
        </Section>

        <Section title={t("privacyPage.contactTitle")}>
          <p>
            {t("privacyPage.emailLabel")}{" "}
            <a href="mailto:support@worldcreatorventures.com" className="text-primary-100 underline">
              support@worldcreatorventures.com
            </a>
          </p>
          <p className="mt-1">
            {t("privacyPage.phoneLabel")}{" "}
            <a href="tel:+917050009899" className="text-primary-100 underline">
              +91 70500 09899
            </a>
          </p>
        </Section>
      
      </div>
    </div>
  );
};

const Section = ({ title, children }) => (
  <div>
    <h2 className="text-base font-semibold text-gray-900 dark:text-white mb-2">{title}</h2>
    <div className="text-sm space-y-1">{children}</div>
  </div>
);

export default PrivacyPolicyPage;
